// extracted by mini-css-extract-plugin
export default {"nav_icon1":"burgerMenu_nav_icon1__EqJYv","open":"burgerMenu_open__trLWl"};